// src/pages/Destinations/Destinations.jsx
import React, { useState, useMemo } from 'react';
import DestinationCard from '../../components/DestinationCard/DestinationCard';
import BackButton from '../../components/BackButton/BackButton';
import { destinations } from '../../data/destinations';
import { formatCurrency } from '../../utils/pricing';
import './Destinations.css';

const Destinations = () => {
  // continents-first UI: show continents, then destinations on click
  const continents = useMemo(() => {
    const set = new Set(destinations.map(d => d.location || 'Unknown'));
    return Array.from(set).filter(Boolean);
  }, []);

  const [selectedContinent, setSelectedContinent] = useState(null);

  const filteredDestinations = useMemo(() => {
    if (!selectedContinent) return [];
    return destinations.filter(d => d.location === selectedContinent);
  }, [selectedContinent]);

  return (
    <div className="destinations-page">
      <div className="container">
        <div className="page-header">
          <h1>Nos Destinations</h1>
          <p>Découvrez toutes nos destinations de rêve</p>
        </div>

        <div className="filters">
          {!selectedContinent ? (
            <div className="continent-grid">
              {continents.map(cont => (
                <button
                  key={cont}
                  className="continent-card"
                  onClick={() => setSelectedContinent(cont)}
                >
                  <div className="continent-name">{cont}</div>
                  <div className="continent-count">{destinations.filter(d => d.location === cont).length} destinations</div>
                </button>
              ))}
            </div>
          ) : (
            <>
                  <div className="continent-actions">
                    <h2 style={{marginLeft: '0'}}>{selectedContinent}</h2>
                  </div>

              <div className="continent-destinations">
                {filteredDestinations.map(destination => (
                  <DestinationCard key={destination.id} destination={destination} />
                ))}
              </div>
              {/* bottom-aligned back button for the continent view */}
              <div style={{ marginTop: '1.25rem' }}>
                <BackButton onClick={() => setSelectedContinent(null)} label="← Retour aux continents" />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Destinations;